import { Component, Input } from '@angular/core';
import { LocaleDurationPipe } from '@app/pipes/locale-duration.pipe';
import { MoneyPipe } from '@app/pipes/money.pipe';
import { SubscriptionPlanDirective } from '@app/shared/subscription-plan/subscription-plan.directive';
import { TooltipDirective } from '@sb/tooltip';
import { PlanType } from '@shiftbase-com/ts-shared/models';

@Component({
  selector: 'timesheet-total',
  templateUrl: './timesheet-total.component.html',
  imports: [MoneyPipe, LocaleDurationPipe, SubscriptionPlanDirective, TooltipDirective],
})
export class TimesheetTotalComponent {
  @Input()
  time: number;
  @Input()
  salary: number;
  @Input()
  showSalary: boolean;
  @Input()
  totalRow: boolean;
  @Input()
  coc: number;
  @Input()
  showCoc = false;

  planType = PlanType;
}
